module.exports = __webpack_public_path__ + "static/media/thickCross.a9ed5074.svg";